<div class="card-container-shadow container-table" [class.hidden]="hidden" [ngStyle]="{'height': hidden ? '0px' : 'auto', 'overflow': hidden ? 'hidden'
  : 'auto'}">
  <nz-table
    #measurementsTable
    [nzVirtualItemSize]="44"
    [nzData]="oldAppointments.length> 0 ? oldAppointments : []"
    [nzFrontPagination]="false"
    [nzShowPagination]="false"
    [nzScroll]="{ x: '1080px', y: (maxVisibleRows * 44) + 'px'}"
    nzSize="small"
    >
    <thead>
      <tr class="header">
        <th nzWidth="200px">FECHA</th>
        <th nzWidth="100px">DURACIÓN</th>
        <th nzWidth="200px">PACIENTE</th>
        <th nzWidth="230px">OBJETIVOS CLÍNICOS</th>
        <th nzWidth="150px">ESTATUS</th>
        <th nzWidth="150px">NOTAS</th>
        <th *ngIf="userType === 'expert'" [nzWidth]="'50px'" [nzRight]="oldAppointments.length > 0 ? true : false"></th>
      </tr>
    </thead>
    <tbody>
      <ng-container *ngFor="let service of oldAppointments; index as i">
        <tr *ngFor="let item of service.appointments; index as i">
          <td>{{ item.startDate.date | date }}
            {{ item?.startDate.hour > 12 ? item?.startDate.hour - 12 : item?.startDate.hour}}:{{ item?.startDate.minute === 0 ? '00' :
            item.startDate.minute }}
            {{ item?.startDate.hour >= 12 ? ' PM' : ' AM' }}
          </td>
          <td nz-popover="" nzPopoverTitle=""
          [nzPopoverContent]="'Duración real de la cita: ' + (item.duration ? (item.duration <= 59 ? item.duration + ' seg' : (item.duration / 60).toFixed(2) + ' min') : 'No establecido')">
            <span nz-icon nzType="info-circle" nzTheme="outline"></span>
            {{ item.minutes }} min
          </td>
          <td>
            <div class="column only-one-patient">
              <!-- <app-avatar-group [users]="item.users"></app-avatar-group> -->
              <app-avatar-user
              [image]="item.users[0].profileImageURL"
              [name]="item.users[0].name"
              [lastname]="item.users[0].lastname"
              [width]="25"
              [fontSize]="'10px'"></app-avatar-user>
              <p class="tw-truncate tw-ml-3" *ngIf="item.users.length === 1">{{ (item.users[0].name ?? '') + ' ' + (item.users[0].lastname ?? '') }}</p>
            </div>
          </td>
          <td>
            <p
              *ngIf="item.users?.length > 0 && item.users[0].clinicObjectives?.length > 0; else notClinicObjectives"
              class="tw-cursor-pointer"
              nz-popover="" [nzPopoverTitle]="objectivesTitleTemplate" [nzPopoverContent]="objectivesTemplate"
              nzPopoverPlacement="top" nzPopoverTrigger="click"
            >
              {{ item.users[0].clinicObjectives[0].text }}...
            </p>

            <ng-template #objectivesTitleTemplate>
              <p class="text-subtitle">Objetivos clínicos</p>
            </ng-template>

            <ng-template #objectivesTemplate>
              <div>
                <p class="text-info-sm" *ngFor="let objective of item.users[0].clinicObjectives">- {{ objective.text }}</p>
              </div>
            </ng-template>
            <ng-template #notClinicObjectives>
              <p class="text-info">Sin objetivos clínicos</p>
            </ng-template>
          </td>
          <td>
            <nz-tag class="tag" [style.background-color]="item.status | setAppointmentStatusColor">
              {{ item.status | getTranslateEnum: 'appointmentStatus' }}
            </nz-tag>
          </td>
          <td>
            <ng-container *ngIf="(item | getNotesByUser) as total; else notNotes">
              <p class="cursor-pointer notes" (click)="onEmitViewNotes(service.serviceId, item._id, item?.users)">
                ver {{ total }} {{ total > 1 ? 'notas' : 'nota' }}
              </p>
            </ng-container>
            <ng-template #notNotes>
              <p class="text-info">No hay notas</p>
            </ng-template>
          </td>
          <td nzRight *ngIf="userType === 'expert'">
            <div class="action-column">
              <div class="more-options">
                <div class="more" nz-dropdown nzTrigger="click" [nzDropdownMenu]="menu" [class.opacity-0]="userType === 'patient'">
                  <i nz-icon nzType="ellipsis" nzTheme="outline"></i>
                </div>
              </div>
              <nz-dropdown-menu #menu="nzDropdownMenu">
                <ul nz-menu nzSelectable *ngIf="userType !== 'patient'">
                  <li nz-menu-item (click)="onEmitAddNote(item._id)">
                    <i style="margin-right: 5px;" nz-icon nzType="plus" nzTheme="outline"></i>
                    Agregar nota
                  </li>
                  <li nz-menu-divider></li>
                  <li nz-menu-item nzDanger>
                    <i style="margin-right: 5px;" nz-icon nzType="delete" nzTheme="outline"></i>
                    eliminar
                  </li>
                </ul>
              </nz-dropdown-menu>
            </div>
          </td>
        </tr>
      </ng-container>
    </tbody>
  </nz-table>
</div>
